// extracted by mini-css-extract-plugin
export default {"loader-container":"FVf6SOgOEkeA17ldHk4p-A==","loader":"DB4YbtEm7WFLaVnTCjMfuQ=="};